export default __webpack_public_path__ + "static/media/slide11.41909881.png";